import React, { ReactNode, useContext, useEffect, useState } from 'react';
import { SafeAreaProvider, SafeAreaView } from 'react-native-safe-area-context';
import { StyleSheet } from 'react-native';
import DyteUIStore from '../lib/context-provider/store';
import { DyteUIContext } from '../lib/context-provider/ui-context';

export default function ({ children }: { children: ReactNode }) {
  const initialContext = useContext(DyteUIContext);
  const [storeStates, setStoreStates] = useState(initialContext.storeStates);
  const setStates = (newState) => {
    setStoreStates(newState);
    DyteUIStore.setStates(newState);
  };

  useEffect(() => {
    const unsubscribe = DyteUIStore.subscribe((newState) => {
      setStoreStates(newState);
    });
    return () => unsubscribe();
  }, []);

  const storeColors = storeStates.designSystem.colors;
  const styles = StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: storeColors.background[900],
    },
  });
  return (
    <SafeAreaProvider>
      <SafeAreaView style={styles.container}>
        <DyteUIContext.Provider value={{ storeStates, setStates }}>
          {children}
        </DyteUIContext.Provider>
      </SafeAreaView>
    </SafeAreaProvider>
  );
}
